import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a121e] text-gray-500 py-10 px-4 text-center text-xs border-t border-white/5" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <p className="mb-2" data-id="element-52">
          © 2026 Salud y Adolescencia 360 — RincónDocente360. Todos los
          derechos reservados.
        </p>
        <p data-id="element-53">
          RincónDocente360 · Recursos profesionales para docentes argentinos
        </p>
      </div>
    </footer>;
}